import { render, staticRenderFns } from "./RequestType.vue?vue&type=template&id=9e148d02&scoped=true&"
import script from "./RequestType.vue?vue&type=script&lang=js&"
export * from "./RequestType.vue?vue&type=script&lang=js&"
import style0 from "./RequestType.vue?vue&type=style&index=0&id=9e148d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e148d02",
  null
  
)

export default component.exports